export default {
  INSTITUTION: 'Einrichtung',
  ESTABLISHMENT: 'Betriebsstätte',
  ESTABLISHMENT_DOCTOR: 'Arzt',
  DOCTOR: 'Arzt',
  SERVICE_START: 'Dienstbeginn',
  SERVICE_END: 'Dienstende',
  HOURS_ABBR: 'Std.',
  MOBILE_SERVICE: 'Fahrdienst',
  OFFICE_SERVICE: 'Sitzdienst',
  ON_CALL_SERVICE: 'Hintergrunddienst',
  IS_ON_CALL_SERVICE: 'Hintergrunddienst',
  IS_ON_CALL_SERVICE_TOOLTIP:
    'Dies ist ein Hintergrunddienst. Der Vertretende muss sich im Einsatzgebiet befinden. Er/sie wird bei Bedarf von der KV kontaktiert & zu Sitz- oder Fahrdienst eingeteilt.',
};
